import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../../../Options/Classes/OptionsColor";
import { PolygonMaskDrawStroke } from "./PolygonMaskDrawStroke";
export var PolygonMaskDraw = /*#__PURE__*/function () {
  function PolygonMaskDraw() {
    _classCallCheck(this, PolygonMaskDraw);
    this.enable = false;
    this.stroke = new PolygonMaskDrawStroke();
  }
  _createClass(PolygonMaskDraw, [{
    key: "lineWidth",
    get: function get() {
      return this.stroke.width;
    },
    set: function set(value) {
      this.stroke.width = value;
    }
  }, {
    key: "lineColor",
    get: function get() {
      return this.stroke.color;
    },
    set: function set(value) {
      this.stroke.color = OptionsColor.create(this.stroke.color, value);
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;
      if (!data) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      var stroke = (_a = data.stroke) !== null && _a !== void 0 ? _a : {
        color: data.lineColor,
        width: data.lineWidth
      };
      this.stroke.load(stroke);
    }
  }]);
  return PolygonMaskDraw;
}();